import { observer } from 'mobx-react';
import { useLayoutEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { SYSTEM_PATH } from '../../core/configs/constants';
import { saveRedirect } from '../../core/utils/loginRedirect';
import { useStore } from '../../core/utils/hook';
import NotFoundScreen from '../../screens/404/NotFoundScreen';

/** Not logged in: save the target URL (sessionStorage) then redirect to /login */
function RedirectToLogin() {
    const location = useLocation();
    useLayoutEffect(() => {
        saveRedirect(location.pathname, location.search);
    }, [location.pathname, location.search]);
    return <Navigate to={SYSTEM_PATH.LOGIN} replace />;
}

const Authentication = observer((props) => {

    const { role, notAuth, alwaysAccess, redirectHome } = props;
    const { authStore: { token, userInfo } } = useStore();

    if(!notAuth) {
        if(token == null) return <RedirectToLogin />;

        if(!role.includes(userInfo?.roleId)) return <NotFoundScreen/>;
    } else {
        if(!alwaysAccess) {
            if(token) {
                if(redirectHome) return <Navigate to={SYSTEM_PATH.HOME} replace />;
                else return <NotFoundScreen/>;
            }
        } else {
            if(role && token && !role.includes(userInfo?.roleId)) return <NotFoundScreen/>;
        }
    }

    return <Outlet/>
})

export default Authentication;